import {
  enhancedMakeFetchAction,
  generateEndpoint
} from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'
export const POST_CHECKING_USER_PROGRAM_SELL_ORDER_PRICE_ESTIMATE =
  'POST_CHECKING_USER_PROGRAM_SELL_ORDER_PRICE_ESTIMATE'

const apiCall = enhancedMakeFetchAction(
  POST_CHECKING_USER_PROGRAM_SELL_ORDER_PRICE_ESTIMATE,
  ({ id, ...payload }) => ({
    endpoint: generateEndpoint({
      host: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/user-programs/${id}/program-orders/subscribe-estimate`
    }),
    method: 'POST',
    body: payload
  })
)

export default apiCall
